module.exports = __webpack_public_path__ + "static/media/Mountain Climber.4c86bdf6.jpg";